export default __webpack_public_path__ + "static/covid-care-service-mobile-img-d61c67e0d369951baabde70be551be93.png";